const _config={
    api_url: process.env.REACT_APP_API_URL,
    api_secret: process.env.REACT_APP_API_SECRET,
    s3_url: process.env.REACT_APP_S3_URL,
    google_map_key: 'AIzaSyD0ALCs4JlP2lIIvTFGtV2EnM3onh47dpM'
}
export default _config;